/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { PlanDependenciesReportEntryPointEntrypointProps } from './PlanDependenciesReportEntryPoint.entrypoint.types.tsx';

type PlanDependenciesReportEntryPointComponent = EntryPointComponent<
	{},
	{},
	PlanDependenciesReportEntryPointEntrypointProps,
	{}
>;

export const planDependenciesReportEntryPoint: EntryPoint<
	PlanDependenciesReportEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<PlanDependenciesReportEntryPointComponent>(
		/* webpackChunkName: "async-plan-dependencies-report-entrypoint" */ './PlanDependenciesReportPlanDependenciesReport.tsx',
	),
	getPreloadProps: () => ({}),
});
